export default function tariff() {
    let tariffType;
    let tariffPeriod;
    let isAnimating = false;
    let lastIsMobile = null;
    const OPACITY = "opacity";
    const STANDARD = "standard";
    const PREMIUM = "premium";
    const TRANSITIONEND = "transitionend";
    const DISPLAY_NONE = "none";
    const DISPLAY_FLEX = "flex";
    const DISPLAY_BLOCK = "block";
    const MOBILE_SIZE = 768;
    const GAP = 24;
    const MARGIN = 20;
    const CORRECTION_HEIGHT = 2;
    const OFFSET = 100;
    const container = document.querySelector('.js-tariffs__container');
    if (!container) return;

    function fadeOutDescription(description, onComplete) {
        if (!description || !description.classList.contains('tariff-description__show')) {
            if (onComplete) onComplete();
            return;
        }

        description.style.opacity = '0';
        description.style.transform = 'translateY(-20px)';
        description.addEventListener(TRANSITIONEND, function handler(e) {
            if (e.propertyName === OPACITY) {
                description.removeEventListener(TRANSITIONEND, handler);
                description.classList.remove('tariff-description__show');
                description.style.display = DISPLAY_NONE;
                description.style.transition = 'none';
                if (onComplete) onComplete();
            }
        });
    }

    function fadeInDescription(description, onComplete) {
        if (!description || description.classList.contains('tariff-description__show')) {
            if (onComplete) onComplete();
            return;
        }

        description.style.display = DISPLAY_BLOCK;
        description.style.opacity = '0';
        description.style.transform = 'translateY(-20px)';
        description.style.transition = 'none';

        requestAnimationFrame(() => {
            description.style.transition = 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out';
            description.style.opacity = '1';
            description.style.transform = 'translateY(0)';
            description.classList.add('tariff-description__show');

            description.addEventListener(TRANSITIONEND, function handler(e) {
                if (e.propertyName === OPACITY) {
                    description.removeEventListener(TRANSITIONEND, handler);
                    if (onComplete) onComplete();
                }
            });
        });
    }

    function scrollToDescriptionWithOffset() {
        const descriptionBlock = document.querySelector(`.js-tariffs__description-${tariffType}[data-period="${tariffPeriod}"]`);
        const description = descriptionBlock?.querySelector(`.js-tariff-description[data-period="${tariffPeriod}"]`);
        if (!description) return;

        const rect = description.getBoundingClientRect();
        const scrollToPosition = window.pageYOffset + rect.top - OFFSET;
        window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
    }

    function switchTariffDescription(version, periodId) {
        const currentDescription = document.querySelector('.js-tariff-description.tariff-description__show');
        if (!currentDescription || !container) return;

        tariffType = version;
        tariffPeriod = periodId;

        const newDescriptionBlock = document.querySelector(`.js-tariffs__description-${version}[data-period="${periodId}"]`);
        const newDescription = newDescriptionBlock?.querySelector(`.js-tariff-description[data-period="${periodId}"]`);
        if (!newDescription) return;

        const isMobile = window.innerWidth <= MOBILE_SIZE;

        currentDescription.classList.remove('tariff-description__show');
        currentDescription.style.display = DISPLAY_NONE;

        newDescription.dataset.version = version;
        newDescription.classList.toggle('tariff-description__standard', version === STANDARD);
        newDescription.style.display = DISPLAY_FLEX;
        newDescription.classList.add('tariff-description__show');

        if (isMobile) {
            container.classList.toggle('tariffs__mobile-standard', version === STANDARD);
        }

        clearAllArrowHighlights();
        highlightButtonsForType(version);
        highlightActualCard(version, periodId);
    }

    function highlightButtonsForType(type) {
        const buttons = document.querySelectorAll(`.js-tariffs__${type}-button svg`);
        if (!buttons.length) return;
        buttons.forEach(svg => svg.classList.add('tariffs__opened-desc'));
    }

    function clearAllArrowHighlights() {
        document.querySelectorAll('.js-tariffs__details-button svg').forEach(svg => {
            svg.classList.remove('tariffs__opened-desc');
        });
    }

    function highlightActualCard(type, period) {
        document.querySelectorAll('.js-tariffs__card-block-standard, .js-tariffs__card-block-premium, .js-tariffs__card-block-trial')
            .forEach(card => card.classList.remove('tariffs__actual-tariff'));

        const typeMap = {
            'standard': 'standard',
            'premium': 'premium',
            'new': 'trial'
        };

        const card = document.querySelector(`.js-tariffs__card-block-${typeMap[type]}[data-period="${period}"]`);
        if (card) {
            card.classList.add('tariffs__actual-tariff');
        }
    }

    function onTransitionEndUpdateDescription(e) {
        if (e.propertyName !== OPACITY) return;

        const description = e.currentTarget;
        description.removeEventListener(TRANSITIONEND, onTransitionEndUpdateDescription);
        description.dataset.version = tariffType;
        description.classList.toggle('tariff-description__standard', tariffType === STANDARD);
        requestAnimationFrame(() => {
            description.classList.add('tariff-description__show');
            isAnimating = false;
        });
    }

    function handleDescriptionFadeOut() {
        const description = document.querySelector(`.js-tariffs__description-${tariffType}[data-period="${tariffPeriod}"]`)
            ?.querySelector(`.js-tariff-description[data-period="${tariffPeriod}"]`);
        if (!description || !container) return;

        if (window.innerWidth <= MOBILE_SIZE) {
            container.classList.toggle('tariffs__mobile-standard', tariffType === STANDARD);
        }
        description.dataset.version = tariffType;
        if (window.innerWidth > MOBILE_SIZE) {
            description.classList.toggle('tariff-description__standard', tariffType === STANDARD);
        }
        fadeInDescription(description, handleDescriptionFadeInComplete);
    }

    function handleDescriptionFadeInComplete() {
        if (window.innerWidth <= MOBILE_SIZE) scrollToDescriptionWithOffset();
        isAnimating = false;
    }

    function toggleTariffDescription(version, periodId) {
        tariffType = version;
        tariffPeriod = periodId;

        if (isAnimating) return;
        isAnimating = true;

        const descriptionBlock = document.querySelector(`.js-tariffs__description-${tariffType}[data-period="${tariffPeriod}"]`);
        const description = descriptionBlock?.querySelector(`.js-tariff-description[data-period="${tariffPeriod}"]`);

        const allDescriptions = document.querySelectorAll('.js-tariff-description.tariff-description__show');
        allDescriptions.forEach(desc => {
            if (desc !== description) {
                fadeOutDescription(desc, () => desc.style.display = DISPLAY_NONE);
            }
        });

        if (!description || !container) {
            isAnimating = false;
            return;
        }

        const isMobile = window.innerWidth <= MOBILE_SIZE;
        clearAllArrowHighlights();
        highlightButtonsForType(version);

        const currentVersion = description.dataset.version;

        if (description.classList.contains('tariff-description__show')) {
            if (currentVersion !== version) {
                if (!isMobile) {
                    description.classList.remove('tariff-description__show');
                    description.addEventListener(TRANSITIONEND, onTransitionEndUpdateDescription);
                } else {
                    fadeOutDescription(description, handleDescriptionFadeOut);
                }
                highlightActualCard(version, periodId);
            } else {
                fadeOutDescription(description, () => {
                    description.style.display = DISPLAY_NONE;
                    clearAllArrowHighlights();
                    if (isMobile) {
                        container.classList.remove('tariffs__mobile-standard');
                    }
                    document.querySelectorAll('.tariffs__actual-tariff')
                        .forEach(card => card.classList.remove('tariffs__actual-tariff'));
                    isAnimating = false;
                });
            }
        } else {
            description.dataset.version = version;
            if (isMobile) {
                container.classList.toggle('tariffs__mobile-standard', version === STANDARD);
            } else {
                description.classList.remove('tariff-description__standard');
                description.classList.remove('tariff-description__new');

                if (version === STANDARD) {
                    description.classList.add('tariff-description__standard');
                }
                if (version === 'new') {
                    description.classList.add('tariff-description__new');
                }
            }
            fadeInDescription(description, handleDescriptionFadeInComplete);
            highlightActualCard(version, periodId);
        }
    }

    function handleResize() {
        const isMobile = window.innerWidth <= MOBILE_SIZE;

        if (lastIsMobile === null) {
            lastIsMobile = isMobile;
            return;
        }

        if (lastIsMobile !== isMobile) {
            let description;

            if (tariffType && tariffPeriod) {
                const descriptionBlock = document.querySelector(`.js-tariffs__description-${tariffType}[data-period="${tariffPeriod}"]`);
                description = descriptionBlock?.querySelector(`.js-tariff-description[data-period="${tariffPeriod}"]`);
            } else {
                description = document.querySelector('.js-tariff-description.tariff-description__show');
                if (description) {
                    tariffType = description.dataset.version;
                    tariffPeriod = description.dataset.period;
                }
            }

            if (description && container && description.classList.contains('tariff-description__show')) {
                fadeOutDescription(description, () => {
                    description.style.display = DISPLAY_NONE;
                    container.classList.remove('tariffs__mobile-standard');
                    clearAllArrowHighlights();
                });
                document.querySelectorAll('.tariffs__actual-tariff')
                    .forEach(card => card.classList.remove('tariffs__actual-tariff'));
            }
            lastIsMobile = isMobile;
        }
    }

    function handlePeriodTabClick(event) {
        const tab = event.currentTarget;
        const periodTabs = document.querySelectorAll('.js-tariffs__period-tab');
        periodTabs.forEach(t => t.classList.remove('tariffs__active'));
        tab.classList.add('tariffs__active');
        const periodId = tab.dataset.period;
        showPeriod(periodId);
        switchTariffDescription(tariffType, periodId);


        const customOptions = document.querySelectorAll('.js-tariffs__period-select-option');
        customOptions.forEach(opt => {
            opt.classList.remove('tariffs__selected');
            if (opt.dataset.value === periodId) {
                opt.classList.add('tariffs__selected');
                const currentDisplay = document.querySelector('.js-tariffs__period-select-current');
                if (currentDisplay) {
                    currentDisplay.textContent = opt.textContent;
                }
            }
        });
    }

    function showPeriod(periodId) {
        const firstTariffElements = document.querySelectorAll('.js-tariffs__first-container-card');
        const otherTariffElements = document.querySelectorAll('.js-tariffs__card-block-standard, .js-tariffs__card-block-premium');
        const trialTariffElements = document.querySelectorAll('.js-tariffs__card-block-trial'); // 👈 Добавили

        firstTariffElements.forEach(el => {
            el.style.display = (el.dataset.period === periodId) ? DISPLAY_FLEX : DISPLAY_NONE;
        });

        otherTariffElements.forEach(el => {
            el.style.display = (el.dataset.period === periodId) ? DISPLAY_FLEX : DISPLAY_NONE;
        });

        trialTariffElements.forEach(el => {
            el.style.display = (el.dataset.period === periodId) ? DISPLAY_FLEX : DISPLAY_NONE; // 👈 Обрабатываем новый тариф
        });
    }

    function initCustomSelect() {
        const customSelect = document.querySelector('.js-tariffs__period-select');
        if (!customSelect) return;

        const trigger = customSelect.querySelector('.js-tariffs__period-select-trigger');
        const currentDisplay = customSelect.querySelector('.js-tariffs__period-select-current');
        const dropdown = customSelect.querySelector('.js-tariffs__period-select-dropdown');
        const options = customSelect.querySelectorAll('.js-tariffs__period-select-option');
        const svgIcon = trigger?.querySelector('svg');

        function closeDropdown() {
            if (dropdown) {
                dropdown.style.display = DISPLAY_NONE;
                if (svgIcon) {
                    svgIcon.classList.remove('tariffs__selected-icon');
                }
            }
        }

        function toggleDropdown() {
            if (!dropdown) return;
            if (dropdown.style.display === DISPLAY_FLEX) {
                closeDropdown();
            } else {
                dropdown.style.display = DISPLAY_FLEX;
                if (svgIcon) {
                    svgIcon.classList.add('tariffs__selected-icon');
                }
            }
        }

        let selectedOptionElement = [...options].find(opt =>
            opt.hasAttribute('data-selected') || opt.classList.contains('tariffs__selected')
        );
        if (!selectedOptionElement && options.length) {
            selectedOptionElement = options[0];
            selectedOptionElement.classList.add('tariffs__selected');
        } else if (selectedOptionElement) {
            selectedOptionElement.classList.add('tariffs__selected');
        }

        if (selectedOptionElement && currentDisplay) {
            currentDisplay.textContent = selectedOptionElement.textContent;
        }

        if (trigger) {
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleDropdown();
            });
        }

        options.forEach((option) => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();

                options.forEach(o => o.classList.remove('tariffs__selected'));
                option.classList.add('tariffs__selected');

                if (currentDisplay) {
                    currentDisplay.textContent = option.textContent;
                }
                closeDropdown();

                const selectedPeriodId = option.dataset.value;
                const periodTab = document.querySelector(`.js-tariffs__period-tab[data-period="${selectedPeriodId}"]`);
                if (periodTab) {
                    periodTab.click();
                }
            });
        });

        document.addEventListener('click', (e) => {
            if (!customSelect.contains(e.target)) {
                closeDropdown();
            }
        });
    }

    function handleDOMContentLoaded() {
        const periodTabs = document.querySelectorAll('.js-tariffs__period-tab');
        periodTabs.forEach(tab => {
            tab.addEventListener('click', handlePeriodTabClick);
        });

        const activeTab = document.querySelector('.js-tariffs__period-tab.tariffs__active');
        if (activeTab) {
            showPeriod(activeTab.dataset.period);
        } else if (periodTabs[0]) {
            periodTabs[0].classList.add('tariffs__active');
            showPeriod(periodTabs[0].dataset.period);
        }

        const tariffSpans = document.querySelectorAll('.js-tariffs__period-tab');
        tariffSpans.forEach((span, index) => {
            span.addEventListener('click', () => handleTariffSpanClick(span, index));
        });

        initCustomSelect();

        handleResize();
    }

    function handleTariffSpanClick(span, index) {
        const tariffSpans = document.querySelectorAll('.js-tariffs__period-tab');
        tariffSpans.forEach(s => s.classList.remove('tariffs__active'));
        span.classList.add('tariffs__active');


        const selectedPeriodId = span.dataset.period;
        const rows = document.querySelectorAll('.js-tariff-description__table tbody tr');
        rows.forEach(row => row.classList.remove('tariff-description__selected'));

        const currentDescriptions = document.querySelectorAll(`.js-tariff-description[data-period="${selectedPeriodId}"]`);
        currentDescriptions.forEach(desc => {
            if (tariffType === "new") {
                toggleTariffDescription("new", selectedPeriodId);
            }

            const tableRows = desc.querySelectorAll('.js-tariff-description__table tbody tr');
            const targetRow = tableRows[index];
            if (targetRow) {
                targetRow.classList.add('tariff-description__selected');
            }
        });

    }

    function onWindowResize() {
        const openedDescription = document.querySelector('.js-tariff-description.tariff-description__show');

        if (openedDescription) {
            requestAnimationFrame(() => {

            });
        }
        handleResize();
    }

    function debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
    window.addEventListener('resize', debounce(onWindowResize, 200));

    window.toggleTariffDescription = toggleTariffDescription;
}
